/* eslint-disable import/no-anonymous-default-export */
import {
    ADD_BRAND_BEGIN,
    ADD_BRAND_FAIL,
    ADD_BRAND_MIDDLEWARE,
    ADD_MODEL_BEGIN,
    ADD_MODEL_FAIL,
    ADD_PRODUCT_SERIES_BEGIN,
    ADD_PRODUCT_SERIES_FAIL,
    GET_BRAND_BEGIN,
    GET_BRAND_FAIL,
    GET_MODEL_BEGIN,
    GET_MODEL_FAIL,
    GET_PRODUCT_SERIES_BEGIN,
    GET_PRODUCT_SERIES_FAIL,
    RESET_STATE,
    GET_BRAND_MIDDLEWARE,
    ADD_PRODUCT_SERIES_MIDDLEWARE_SUCCESS,
    GET_PRODUCT_SERIES_MIDDLEWARE_SUCCESS,
    REMOVE_DATA,
    ADD_MODEL_MIDDLEWARE_SUCCESS,
    GET_MODEL_MIDDLEWARE_SUCCESS,
    EDIT_BRAND_SUCCESS,
    EDIT_PRODUCT_SERIES_SUCCESS,
    EDIT_MODEL_SUCCESS,
    SET_BRAND_PRODUCT_MODEL,
    SET_SEARCH_BRAND_PRODUCT_MODEL,
    SET_SEARCH_IDENTIFICATION_DATA,
    RESET_DEVICE_ACTION,
    SET_CYLINDER_TYPE
} from "./types";

const initialState = {
    loading: false,
    success: false,
    status: "",
    cylinderType: { key: null, type: null },
    brandLists: { list: [], pageNo: 0, hasMore: false, lastPage: 0 },
    productLists: { list: [], pageNo: 0, hasMore: false, lastPage: 0 },
    modelLists: { list: [], pageNo: 0, hasMore: false, lastPage: 0 },
    equipmentIdentificationData: { list: [], pageNo: 0, hasMore: false, lastPage: 0 },
    searchedBrandLists: { list: [], pageNo: 0, hasMore: false, lastPage: 0 },
    searchedProductLists: { list: [], pageNo: 0, hasMore: false, lastPage: 0 },
    searchedModelLists: { list: [], pageNo: 0, hasMore: false, lastPage: 0 },
    searchedIdentificationData: { list: [], pageNo: 0, hasMore: false, lastPage: 0 },
    errorMessage: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ADD_BRAND_BEGIN:
            return {
                ...state,
                loading: true,
                success: false,
                status: "start",
                errorMessage: "",
            }
        case SET_CYLINDER_TYPE:
            return {
                ...state,
                cylinderType: action?.payload
            }
        case ADD_BRAND_FAIL:
            return {
                ...state,
                loading: false,
                status: "fail",
                success: false,
                errorMessage: action.payload || "something wrong",
            }

        case ADD_BRAND_MIDDLEWARE:
            return {
                ...state,
                loading: false,
                status: "success",
                success: true,
                errorMessage: "",
            };

        case EDIT_BRAND_SUCCESS:
            let cloneData = [...state.brandLists.list]
            const ind = cloneData.findIndex(p => p.id === action.payload.id)
            cloneData[ind] = {
                ...cloneData[ind],
                ...action.payload
            }

            return {
                ...state,
                brandLists: {
                    ...state.brandLists,
                    list: cloneData
                },
                loading: false,
                status: "success",
                success: true,
                errorMessage: "",
            };
        case EDIT_PRODUCT_SERIES_SUCCESS:
            let cloneDataProduct = [...state.productLists.list]
            const index = cloneDataProduct.findIndex(p => p.id === action.payload.id)
            cloneDataProduct[index] = {
                ...cloneDataProduct[index],
                ...action.payload
            }
            return {
                ...state,
                productLists: {
                    ...state.productLists,
                    list: cloneDataProduct
                },
                loading: false,
                status: "success",
                success: true,
                errorMessage: "",
            };
        case EDIT_MODEL_SUCCESS:
            let cloneDataModel = [...state.modelLists.list]
            const indexModel = cloneDataModel.findIndex(p => p.id === action.payload.id)
            cloneDataModel[indexModel] = {
                ...cloneDataModel[indexModel],
                ...action.payload
            }
            return {
                ...state,
                modelLists: {
                    ...state.modelLists,
                    list: cloneDataModel
                },
                loading: false,
                status: "success",
                success: true,
                errorMessage: "",
            };
        case GET_BRAND_BEGIN:
            return {
                ...state,
                loading: true,
                success: false,
                status: "start",
                errorMessage: "",
            }
        case GET_BRAND_FAIL:
            return {
                ...state,
                loading: false,
                status: "fail",
                success: false,
                errorMessage: action.payload || "something wrong",
            }

        case GET_BRAND_MIDDLEWARE:
            return {
                ...state,
                loading: false,
                status: "success",
                success: true,
                brandLists: action.payload,
                errorMessage: "",
            };
        case GET_PRODUCT_SERIES_BEGIN:
            return {
                ...state,
                loading: true,
                success: false,
                status: "start",
                errorMessage: "",
            }
        case GET_PRODUCT_SERIES_FAIL:
            return {
                ...state,
                loading: false,
                status: "fail",
                success: false,
                errorMessage: action.payload || "something wrong",
            }

        case GET_PRODUCT_SERIES_MIDDLEWARE_SUCCESS:
            return {
                ...state,
                loading: false,
                status: "success",
                success: true,
                productLists: action.payload,
                errorMessage: "",
            };
        case GET_MODEL_BEGIN:
            return {
                ...state,
                loading: true,
                success: false,
                status: "start",
                errorMessage: "",
            }
        case GET_MODEL_FAIL:
            return {
                ...state,
                loading: false,
                status: "fail",
                success: false,
                errorMessage: action.payload || "something wrong",
            }

        case GET_MODEL_MIDDLEWARE_SUCCESS:
            return {
                ...state,
                loading: false,
                status: "success",
                success: true,
                modelLists: action.payload,
                errorMessage: "",
            };
        case ADD_PRODUCT_SERIES_BEGIN:
            return {
                ...state,
                loading: true,
                success: false,
                status: "start",
                errorMessage: "",
            }
        case ADD_PRODUCT_SERIES_FAIL:
            return {
                ...state,
                loading: false,
                status: "fail",
                success: false,
                errorMessage: action.payload || "something wrong",
            }

        case ADD_PRODUCT_SERIES_MIDDLEWARE_SUCCESS:
            return {
                ...state,
                loading: false,
                status: "success",
                success: true,
                errorMessage: "",
            };

        case ADD_MODEL_BEGIN:
            return {
                ...state,
                loading: true,
                success: false,
                status: "start",
                errorMessage: "",
            }
        case ADD_MODEL_FAIL:
            return {
                ...state,
                loading: false,
                status: "fail",
                success: false,
                errorMessage: action.payload || "something wrong",
            }

        case ADD_MODEL_MIDDLEWARE_SUCCESS:
            return {
                ...state,
                loading: false,
                status: "success",
                success: true,
                errorMessage: "",
            };

        case RESET_STATE:
            return {
                ...state,
                loading: false,
                status: "",
                success: false,
                errorMessage: "",
            };

        case REMOVE_DATA:
            let CloneProductLists = { ...state.productLists }
            let CloneModelLists = { ...state.modelLists }
            action.payload === "product" ? CloneProductLists = {} : CloneModelLists = {}
            return {
                ...state,
                loading: false,
                status: "",
                success: false,
                errorMessage: "",
                productLists: CloneProductLists,
                modelLists: CloneModelLists
            };

        case SET_BRAND_PRODUCT_MODEL:
            let data = {}
            if (action.payload?.type === "brand") {
                data = {
                    brandLists: {
                        list: [...state?.brandLists?.list, ...action.payload.payload?.list],
                        pageNo: action.payload.payload?.pageNo,
                        hasMore: action.payload.payload?.hasMore,
                        lastPage: action.payload.payload?.lastPage
                    }
                }
            } else if (action.payload?.type === "product") {
                data = {
                    productLists: {
                        list: [...state?.productLists?.list, ...action.payload.payload?.list],
                        pageNo: action.payload.payload?.pageNo,
                        hasMore: action.payload.payload?.hasMore,
                        lastPage: action.payload.payload?.lastPage
                    }
                }
            } else if (action.payload?.type === "model") {
                data = {
                    modelLists: {
                        list: [...state?.modelLists?.list, ...action.payload.payload?.list],
                        pageNo: action.payload.payload?.pageNo,
                        hasMore: action.payload.payload?.hasMore,
                        lastPage: action.payload.payload?.lastPage
                    }
                }
            } else if (action.payload?.type === "equipmentIdentificationNumber") {
                data = {
                    equipmentIdentificationData: {
                        list: [...state?.equipmentIdentificationData?.list, ...action.payload.payload?.list],
                        pageNo: action.payload.payload?.pageNo,
                        hasMore: action.payload.payload?.hasMore,
                        lastPage: action.payload.payload?.lastPage
                    }
                }
            }
            return {
                ...state,
                ...data,
                loading: false
            }

        case SET_SEARCH_BRAND_PRODUCT_MODEL:
            let searchedData = {};
            if (action.payload?.type === "brand") {
                if (action.payload?.pageNo !== 1) {
                    searchedData = {
                        searchedBrandLists: {
                            list: [...state?.searchedBrandLists?.list, ...action.payload.payload?.list],
                            pageNo: action.payload.payload?.pageNo,
                            hasMore: action.payload.payload?.hasMore,
                            lastPage: action.payload.payload?.lastPage
                        }
                    }
                } else {
                    searchedData = { searchedBrandLists: action.payload.payload }
                }
            }
            if (action.payload?.type === "product") {
                if (action.payload?.pageNo !== 1) {
                    searchedData = {
                        searchedProductLists: {
                            list: [...state?.searchedProductLists?.list, ...action.payload.payload?.list],
                            pageNo: action.payload.payload?.pageNo,
                            hasMore: action.payload.payload?.hasMore,
                            lastPage: action.payload.payload?.lastPage
                        }
                    }
                } else {
                    searchedData = { searchedProductLists: action.payload.payload }
                }
            }
            if (action.payload?.type === "model") {
                if (action.payload?.pageNo !== 1) {
                    searchedData = {
                        searchedModelLists: {
                            list: [...state?.searchedModelLists?.list, ...action.payload.payload?.list],
                            pageNo: action.payload.payload?.pageNo,
                            hasMore: action.payload.payload?.hasMore,
                            lastPage: action.payload.payload?.lastPage
                        }
                    }
                } else {
                    searchedData = { searchedModelLists: action.payload.payload }
                }
            }
            if (action.payload?.type === "equipmentIdentificationNumber") {
                if (action.payload?.pageNo !== 1) {
                    searchedData = {
                        searchedIdentificationData: {
                            list: [...state?.searchedIdentificationData?.list, ...action.payload.payload?.list],
                            pageNo: action.payload.payload?.pageNo,
                            hasMore: action.payload.payload?.hasMore,
                            lastPage: action.payload.payload?.lastPage
                        }
                    }
                } else {
                    searchedData = { searchedIdentificationData: action.payload.payload }
                }
            }
            return {
                ...state,
                ...searchedData
            }

        case SET_SEARCH_IDENTIFICATION_DATA:
            return {
                ...state,
                // searchedIdentificationData: action.payload?.pageNo === 1 ? action.payload?.payload : [...state?.searchedIdentificationData?.list, ...action.payload?.payload]
                searchedIdentificationData: {
                    list: [action.payload?.payload?.list],
                    pageNo: action.payload.payload?.pageNo,
                    hasMore: action.payload.payload?.hasMore,
                    lastPage: action.payload.payload?.lastPage
                }
            };

        case RESET_DEVICE_ACTION:
            return {
                ...state, ...action.payload
            };

        default:
            return { ...state };
    }
};
